export default __webpack_public_path__ + "static/media/offer3.2616b786.png";